import classnames from 'classnames';
import Checkbox from 'commons/components/Checkbox';
import React from 'react';
import { useId } from "react-id-generator";
import './styles.scss';

interface CheckboxGroupItemType {
    label: string,
    selected: boolean,
    disabled: boolean,
    value: any,
    visible: boolean
}

interface CheckboxGroupItems extends Array<CheckboxGroupItemType>{}

interface CheckboxGroupProps {
    className?: string,
    checkboxIdPrefix?: string,
    disabled?: boolean,
    id?: string,
    items: CheckboxGroupItems,
    layout?: string,
    name?: string,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onClick?: (e: React.MouseEventHandler<HTMLInputElement>) => void,
    readOnly?: boolean
}

/**
 * Generic checkbox component that displays an attractive checkmark in place of the 
 * default HTML checkbox.
 * 
 * @param {CheckboxGroupProps} props 
 */
function CheckboxGroup(props:CheckboxGroupProps) {

    const elementClassName = classnames('checkbox-group', props.className, { "list-layout": props.layout === 'list', "grid-layout": props.layout === 'grid' });
    const id = props.id || useId(1, "checkboxGroup")[0];

    return (
        <div className={elementClassName} data-testid={id} id={id}>
            {props.items.map((item, index) => {

                if (item.visible === undefined) {
                    item.visible = true;
                }

                return (
                    <Checkbox
                        className={classnames('checkbox', item.visible == true ? '' : 'hidden', item.disabled ? 'disabled' : '')}
                        disabled={props.disabled || item.disabled}
                        idPrefix={props.checkboxIdPrefix ? props.checkboxIdPrefix + index : ''}
                        key={index}
                        checked={item.selected}
                        label={item.label}
                        name={props.name}
                        onChange={props.onChange}
                        onClick={props.onClick}
                        readOnly={props.readOnly}
                        value={item.value ? item.value.toString() : ''}
                    />
                );
            })}
        </div>
    );

}


CheckboxGroup.defaultProps = {
    className: '',
    disabled: false,
    layout: 'grid',
    readOnly: false
};

export default CheckboxGroup;
export type { CheckboxGroupItemType };
